<div [className]="isLoading()?'loader-wrapper':'loader-wrapper hidden'">
  <div class="loader">
    <mat-spinner mode="indeterminate" [diameter]="32"></mat-spinner>
  </div>
</div>
